import { Bars3Icon } from '@/components/Icons'
import { useUiStrings } from '@/hooks/useUiStrings'
import { useStore } from '@/store/useStore'

interface SidebarToggleProps {
  className?: string
  hiddenWhenOpen?: boolean
}

export default function SidebarToggle({
  className = '',
  hiddenWhenOpen = false,
}: SidebarToggleProps) {
  const { t } = useUiStrings()
  const sidebarOpen = useStore((s) => s.sidebarOpen)
  const toggleSidebar = useStore((s) => s.toggleSidebar)
  const isTeamsPanel = useStore((s) => s.isTeamsPanel)

  // Docked inside a Teams call there is no sidebar to open: the panel is the
  // host's chrome, and `AppLayout` leaves ours out entirely.
  if (isTeamsPanel) return null
  if (hiddenWhenOpen && sidebarOpen) return null

  return (
    <button
      type="button"
      onClick={toggleSidebar}
      aria-label={sidebarOpen ? t.hideSidebar : t.showSidebar}
      aria-expanded={sidebarOpen}
      className={[
        'inline-flex h-10 w-10 shrink-0 touch-manipulation items-center justify-center rounded-lg text-[var(--text-secondary)] transition-colors hover:bg-[var(--bg-tertiary)] hover:text-[var(--text-primary)]',
        className,
      ].join(' ')}
    >
      <Bars3Icon className="h-4 w-4" />
    </button>
  )
}
